import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=d43bd15c&"
import script from "./dropdown.vue?vue&type=script&lang=js&"
export * from "./dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\Users\\860552\\Downloads\\work\\kronex-home.by\\bitrix\\templates\\b2bportal_kr\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d43bd15c', component.options)
    } else {
      api.reload('d43bd15c', component.options)
    }
    module.hot.accept("./dropdown.vue?vue&type=template&id=d43bd15c&", function () {
      api.rerender('d43bd15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/dropdown.vue"
export default component.exports